export default {
  StorageClass: "存储类型",
  provisioner: "服务提供者",
  reclaimPolicy: "卷回收策略",
  volumeBindingMode: "卷挂载策略"
};
